import React from 'react';
import { FadeIn } from './ui';
export const Problem = () => {
  return <section className="py-16 px-6" data-id="element-116">
      <div className="max-w-2xl mx-auto" data-id="element-117">
        <FadeIn data-id="element-118">
          <h2 className="text-3xl md:text-4xl text-center mb-10 text-balance" data-id="element-119">
            The physiological trap of the <br data-id="element-120" />
            <span className="italic text-amber" data-id="element-121">"Ceiling Stare"</span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-122">
          <div className="prose prose-invert prose-lg max-w-none text-parchment-muted font-light leading-loose" data-id="element-123">
            <p data-id="element-124">
              The "Ceiling Stare" isn't just annoying; it’s a physiological
              trap. Around 3:00 AM, your body hits a natural temperature dip.
              For most, this is a transition to deep sleep. But for the stressed
              high-achiever, your brain misinterprets this dip as a threat.
            </p>
            <p data-id="element-125">
              It releases a burst of cortisol—your "fight or flight" hormone—to
              wake you up and "check the perimeter." Once you’re awake, your
              analytical mind looks for problems to solve to justify that
              chemical spike.
            </p>
            <p className="text-parchment font-medium text-xl mt-8 text-center italic" data-id="element-126">
              You aren’t broken, and you aren't an insomniac.
            </p>
            <p className="text-center" data-id="element-127">
              You are just stuck in a high-beta brainwave loop that doesn't have
              an "off" switch.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
};